import { render, staticRenderFns } from "./academic_itso_referee_booth.vue?vue&type=template&id=39e49cc2&scoped=true&"
import script from "./academic_itso_referee_booth.vue?vue&type=script&lang=js&"
export * from "./academic_itso_referee_booth.vue?vue&type=script&lang=js&"
import style0 from "./academic_itso_referee_booth.vue?vue&type=style&index=0&id=39e49cc2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39e49cc2",
  null
  
)

export default component.exports